export default __webpack_public_path__ + "static/media/ipad-banner-2.c38be38c.png";